import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initSentry } from "./services/sentry";

initSentry();

const target = document.getElementById("fixel-app-root");
if (target) {
	ReactDOM.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		target
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
